import React from "react";
import { useTranslation } from "react-i18next";
import TextLink from "../../TextLink";
import { externalLinks } from "./externalLinks";
import style from "./style.module.scss";

export default function AccessibilityHeader() {
  const { t } = useTranslation();

  return (
    <div className={style.accessibilityHeaderContainer}>
      <div className={style.accessibilityHeaderButtonsContainer}>
        {/* <span>Acessibilidade:</span>
        <button><span className="material-symbols-sharp">dark_mode</span></button>
        <button><span className="material-symbols-sharp">brightness_5</span></button>
        <button><span className="material-symbols-sharp">format_size</span></button> */}
      </div>
      <div className={style.accessibilityHeaderLinksContainer}>
        {externalLinks.map(({ href, labelKey }) => (
          <TextLink
            className="pgm-label-medium"
            key={href}
            link={href}
            target="_blank"
            text={t(labelKey)}
          />
        ))}
      </div>
    </div>
  );
}
